import { render, staticRenderFns } from "./indexSIImple.vue?vue&type=template&id=68748164"
import script from "./indexSIImple.vue?vue&type=script&lang=js"
export * from "./indexSIImple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports